import { render } from "./MovimientoDetalle.vue?vue&type=template&id=e45a895c"
import script from "./MovimientoDetalle.vue?vue&type=script&lang=js"
export * from "./MovimientoDetalle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__